/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useCallback, useState, useContext } from 'react';
import Swal from 'sweetalert2';

import api from '../services/api';

interface ICodes {
  id: number;
  status: string;
}

interface IEvent {
  end_hour: string;
  hour: string;
  id: number;
  name: string;
  codes: ICodes[];
}

interface AuthState {
  event: IEvent;
}

interface SignInCredentials {
  code: string;
}

interface AuthContextData {
  event: IEvent;
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
}

export const AuthContext = createContext<AuthContextData>(
  {} as AuthContextData
);

export const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const event = localStorage.getItem('@Koro:event');

    if (event) {
      return { event: JSON.parse(event) };
    }

    return {} as AuthState;
  });

  const signIn = useCallback(async ({ code }: SignInCredentials) => {
    try {
      const response = await api.post<IEvent>(`events/session`, {
        code,
      });

      if (response.data.codes[0].status === 'Cadastrado') {
        Swal.fire('Opss...', 'Inválido - código 1001', 'error');
        return;
      }

      if (response.data.codes[0].status === 'Encerrado') {
        Swal.fire('Opss...', 'Inválido - código 1002', 'error');
        return;
      }

      localStorage.setItem('@Koro:event', JSON.stringify(response.data));

      setData({
        event: response.data,
      });
    } catch (error) {
      Swal.fire('Opss...', 'Inválido - código 10', 'error');
    }
  }, []);

  const signOut = useCallback(async () => {
    localStorage.removeItem('@Koro:event');

    setData({} as AuthState);
  }, []);

  return (
    <AuthContext.Provider value={{ event: data.event, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
